import request from "@/axios/index";
import {Base64} from 'js-base64'
export function renderDom(id) {
  return request({
    url: "/custom/selectConfigs?configId=" + id,
    method: "get",
  });
}

export function renderData({ data = {}, params = {} }) {
  return request({
    url: "/custom/selectList",
    method: "post",
    params,
    data,
  });
}

// 归档
export function placeOnFiledata(data, params) {
  return request({
    url: "/custom/archive",
    method: "post",
    params,
    data,
  });
}

export function renderDatalist({ data = {}, params = {} }) {
  return request({
    url: "/custom/selectList",
    method: "post",
    params,
    data,
  });
}
export function exportData(id, data, lessID) {
  return request({
    url: `/custom/export?configId=${id}&productParentTypeId=${lessID}`,
    method: "post",
    responseType: 'blob',
    data,
  });
}
// 刷新存储过程
export function refreshData(id) {
  let count = Math.ceil(Math.random()*10)
  return request({
    url: `/custom/refresh?` + count + `&configId=${id}`,
    method: "post"
  });
}
// 导入
export function importData(id, data) {
  return request({
    url: `custom/import?configId=${id}`,
    method: "post",
    responseType: 'blob',
    data,
  });
}

// 调取商品类别列表
export function getProductCategoryList() {
  return request({
    url: "/productCategory/tree_select",
    method: "get",
    params: {},
  })
}

//添加商品类别
export function addProductCategory(params) {
  return request({
    url: "/productCategory",
    method: "post",
    data: params,
  })
}

//添加商品类别
export function zhuanDan(params) {
  return request({
    url: "/hai_hua/zhuan_dan",
    method: "post",
    data: params,
  })
}

//修改商品类别
export function editProductCategory(params, id) {
  return request({
    url: `/productCategory/${id}`,
    method: "PUT",
    data: params,
  })
}

//修改数据类别
export function editshujuCategory(params) {
  return request({
    url: '/productCategory/product_cat',
    method: "PUT",
    data: params,
  })
}

//删除商品类别
export function delProductCategory(id) {
  return request({
    url: `/productCategory/deleteAllById?id=${id}`,
    method: "DELETE"
  })
}

// 库存明细的占用功能
export function employ(fno, idList) {
  return request({
    url: `/stock/use?fno=${fno}`,
    method: "post",
    data:idList
  })
}

// 新-库存占用
export function occupy(params, data) {
  return request({
    url: '/purchasePlanStock/use',
    method: "post",
    params,
    data
  })
}

// 新-库存占用（批量）
export function occupyBatch(params, data) {
  return request({
    url: '/purchasePlanStock/batch_use',
    method: "post",
    params,
    data
  })
}

// 新-取消占用
export function cancelOccupy(data) {
  return request({
    url: '/purchasePlanStock/un_use',
    method: "post",
    data
  })
}

// 占用明细取消占用功能
export function unEmploy(idList) {
  return request({
    url: `/stock/un_use`,
    method: "post",
    data:idList
  })
}


// 获取打印URL
export function getPrintUrl(data) {
  return request({
    url: '/sys/report/get/url',
    method: "post",
    data,
  })
}

// 获取抬头章
export function getFours(val) {
  return request({
    url: '/addrCtrl/findListByFours?fours=' + val,
    method: "get"
  })
}

// 用户管理同步按钮
export function getSynchronousAssignmentGroup(flag) {
  return request({
    url: '/sys/user/syncAllUserGroup',
    method: "get",
    params: flag,
  })
}

// 占用明细同步更新fcat=-1的数据，qty也需要同步修改
export function updateQty(id) {
  return request({
    url: `/purchasePlanStock/sync?sourceId=${id}`,
    method: "get"
  })
}

// 采购计划-转单
export function toTransOrder(data) {
  return request({
    url: '/purchasePlan/transferOrder',
    method: "post",
    data
  })
}

// 子配件开关
export function switchParts(method) {
  return request({
    url: '/global-config/switch-parts',
    method: method,
  })
}

// 挂牌/取消挂牌
export function updateListingStatus(data) {
  return request({
    url: '/myListing/updateListingStatus',
    method: "post",
    data,
  })
}

// 大厅消息
export function listingListMessage() {
  return request({
    url: '/myListing/listingListMessage',
    method: "get",
  })
}

// 摘牌
export function delistMyListing(data) {
  return request({
    url: `/myListing/delist`,
    method: "post",
    data:data
  })
}

// 批量摘牌
export function batchDelist(data) {
  return request({
    url: '/myListing/batchDelist',
    method: "post",
    data
  })
}

// 批量挂牌
export function batchGlist(data, type) {
  return request({
    url: type && type === 2 ? '/myListing/batchListing?autoType=1' : '/myListing/batchListing',
    method: "post",
    data
  })
}


// 取消摘牌
export function cancelDelist(id) {
  return request({
    url: `/myListing/cancelDelist?id=${id}`,
    method: "post",
  })
}
// 摘牌模块中的挂牌
export function listing(id, num, price, amount) {
  return request({
    url: `/myListing/listing?id=${id}&num=${num || -1}&price=${price|| -1}&amount=${amount|| -1}`,
    method: "post",
  })
}

// 交易完成
export function completeMyListing(id) {
  return request({
    url: `/myListing/complete?id=${id}`,
    method: "post",
  })
}

// 一键生产结算记录
export function generateSettlementRecords(id) {
  return request({
    url: `/myListing/generateSettlementRecords?id=${id}`,
    method: "post",
  })
}

// 生成货转
export function generateGoodsTransfer(id) {
  return request({
    url: `/myListing/generateGoodsTransfer?id=${id}`,
    method: "post",
  })
}


// 生成发票
export function generateInvoice(id) {
  return request({
    url: `/myListing/generateInvoice?id=${id}`,
    method: "post",
  })
}

export function getTreeList(id) {
  return request({
    url: `/myListing/getTreeList?id=${id}`,
    method: "get",
  })
}

export function uploadFile(action,formData) {
  return request({
    url: action,
    method: "post",
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
    responseType: 'json'
  })
}

export function associationPage(params) {
  return request({
    url: `/common/association/page?pageSize=99999`,
    method: "get",
    params
  })
}


export function updateOrderStatus(params) {
  return request({
    url: `/myListing/updateOrderStatus`,
    method: "get",
    params
  })
}

export function checkBalance(data){
  return request({
    url: `/myListing/checkBalance`,
    method: "post",
    data
  })
}

/**
 * 传单据号对账接口
 * @param {string} billNos 单据号
 */
export function checkBalanceByBillNo(billNos){
  return request({
    url: `/myListing/checkBalanceByBillNo`,
    method: "post",
    data:billNos
  })
}

/**
 * 文件在线预览
 * @param {*} accessUrl 文件http预览地址
 */
export const onlinePreview = (accessUrl)=> {
	if(accessUrl) {
    var modifiedUrl = accessUrl
    if (accessUrl.indexOf('http') == -1){
      modifiedUrl = window.baseURL+'/image'+accessUrl.replace(/\\/g, "/");
    }
		let startIndex = accessUrl.lastIndexOf(".")
		let str = accessUrl.substring(startIndex + 1, accessUrl.length).toLowerCase()

		if(str == 'jpeg' || str == 'pdf' || str == 'png' || str == 'jpg' || str == 'jpe' || str == 'pns') {
			// 使用正则表达式提取文件名
			const fileNameMatch = modifiedUrl.match(/\/([^/]+)$/);
			const fileName = fileNameMatch ? fileNameMatch[1] : null;
			console.log("原始文件名：", fileName);
			if (fileName) {
				// 对文件名进行 encodeURIComponent 编码
				const encodedFileName = encodeURIComponent(fileName);
				console.log("编码后的文件名：", encodedFileName);

				// 将编码后的文件名替换回 URL 中
				const replaceUrl = modifiedUrl.replace(fileName, encodedFileName);
				window.open(replaceUrl)
			}
		}else {
			//modifiedUrl = "http://120.224.125.71:8721/mail_upload/reportView?reportName=f287ab5f-6e54-4f1a-9dbc-84fcca750757_aaa.jpg"
			var b64Encoded = Base64.encode(modifiedUrl);
      //console.log(window.onlinePreview +'?url=' + encodeURIComponent(b64Encoded))
      // 创建一个 <a> 标签
        let a = document.createElement('a');
        a.href = window.onlinePreview +'?url=' + encodeURIComponent(b64Encoded);
        a.target = '_blank';
        // 模拟点击操作
        a.click();
        // 移除 <a> 标签
        document.body.removeChild(a);
      //window.open(( window.onlinePreview +'?url=' + encodeURIComponent(b64Encoded), "_blank"));
		}
	}
}

export function attachmentTemplateUpload(data){
  return request({
    url: `/common/attachmentTemplateUpload`,
    method: "post",
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

/** 
 * 模版附件删除
*/
export function deleteAttachmentTemplate(id){
  return request({
    url: `/common/association/deleteAttachmentTemplate?id=${id}`,
    method: "post"
  })
}
/** 
 * 模版附件下载
*/
export function downLoadAttachmentTemplate(id){
  return request({
    url: `/common/association/downLoadAttachmentTemplate?id=${id}`,
    method: "get",
    responseType: 'blob',
  })
}

export function getPreviewUrl(id){
  return request({
    url: `/common/getPreviewUrl/${id}`,
    method: "get",
  })
}

// 货转指令状态
export function getFileStatus(fileStatus){
    switch (parseInt(fileStatus || 0)) {
      case 0:
        return '待签订';
      case 1:
        return '已签订';
      default:
        return '';
  }
}

// 发票状态
export function getInvoiceFileStatus(fileStatus){
  switch (parseInt(fileStatus || 0)) {
    case 0:
      return '待开票';
    case 1:
      return '已开票';
    case 2:
      return '已收票';
    default:
      return '';
  }
}

export function transactionExport(id){
  return request({
    url: '/api/transaction/export?chainId='+id,
    method: "get",
    responseType:'blob'
  })
}


export function editContractDate(dateStr,id){
  return request({
    url: '/myListing/editContractDate?dateStr='+dateStr+'&id='+id,
    method: "post",
  })
}